import { Textarea, Label } from "@windmill/react-ui";

const LabelTextarea = ({
  label,
  register,
  name,
  required,
  validations,
  ...rest
}) => {
  return (
    <div className="w-full flex flex-col">
      <Label className="col-span-4 sm:col-span-2 font-medium text-sm">
        {label}{required && '*'}
      </Label>
      <Textarea
        {...register(`${name}`, {
          required: { value: required, message: `${label} is required!` },
          ...validations,
        })}
        {...rest}
        className="border text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
      />
    </div>
  );
};

export default LabelTextarea;
